var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('FadeTransition',[(!_vm.initialized && _vm.showLoader)?_c('FullLoader'):_vm._e(),(_vm.initialized)?_c('div',[_vm._t("default")],2):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }